/*
  Flowkeeper - Pomodoro timer for power users and teams
  Copyright (c) 2023 Constantine Kulak, Geoffrey Espagne

  This program is free software: you can redistribute it and/or modify
  it under the terms of the GNU General Public License as published by
  the Free Software Foundation; either version 3 of the License, or
  (at your option) any later version.

  This program is distributed in the hope that it will be useful,
  but WITHOUT ANY WARRANTY; without even the implied warranty of
  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
  GNU General Public License for more details.

  You should have received a copy of the GNU General Public License
  along with this program.  If not, see <https://www.gnu.org/licenses/>.
*/

import {useContext} from "react";
import {Banner, Flex, FlexItem,} from '@patternfly/react-core';
import ExclamationCircleIcon from '@patternfly/react-icons/dist/esm/icons/exclamation-circle-icon';
import ConnectionContext from "../context/ConnectionContext";

export function OfflineBanner() {
    const {connection} = useContext(ConnectionContext);
    if (!connection || !connection.isConnected) {
        return <Banner screenReaderText="Offline" variant="red">
                <Flex>
                    <FlexItem>
                        <ExclamationCircleIcon />
                    </FlexItem>
                    <FlexItem>You are offline or signed out.</FlexItem>
                </Flex>
            </Banner>;
    } else {
        return null;
    }
}
